import * as React from "react";
import { Button } from "@material-ui/core";

type ClickEvent<ElementType> = React.MouseEvent<ElementType, MouseEvent>;
type EventListener<EventType> = (event: EventType) => void;

export interface SuccessButtonProps {
  text: string;
  onClick?: EventListener<ClickEvent<HTMLButtonElement>>;
}

export const SuccessButton: React.FunctionComponent<SuccessButtonProps> = (
  props
) => {
  const { onClick, text } = props;
  return (
    <Button variant="contained" color="primary" onClick={onClick}>
      {text}
    </Button>
  );
};
